module.exports = __webpack_public_path__ + "img/i-share-copy.047795bb.svg";